<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#86559f" type="ball-scale-multiple"></ngx-spinner>

<app-header></app-header>
<app-sidebar></app-sidebar>
<router-outlet></router-outlet>
